import ToastContainer from "../components/Toast/ToastContainer";

const Main = ({ children }) => {
	return (
		<main className="h-full overflow-y-auto">
			<ToastContainer />
			{/* Not Tailwind's `container`: its max-width snaps to the viewport
			    breakpoint below the current width, which left 60–240px gutters on
			    tablets (768–1023px) where the sidebar is a drawer. */}
			<div className="mx-auto grid w-full max-w-screen-2xl grid-cols-1 pt-4 px-4 sm:px-6 2xl:px-10">
				{children}
			</div>
		</main>
	);
};

export default Main;
